export const applicationSettingQueryKeys = {
  all: () => "application-setting"
};
